export default {
  chunkArray(arrayToChunk, chunk) {
    let index = 0
    let tempArray = []
    for (index = 0; index < arrayToChunk.length; index += chunk) {
      let chunkedArray = arrayToChunk.slice(index, index + chunk)
      tempArray.push(chunkedArray)
    }
    return tempArray
  },
  sortArray(array, sorting, prop) {
    let sortedArray = []
    if (sorting === 'desc') {
      sortedArray = array.sort(function(a, b) {
        return b[prop] - a[prop]
      })
    } else {
      sortedArray = array.sort(function(a, b) {
        return a[prop] - b[prop]
      })
    }
    return sortedArray
  }
}
